








































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Watch } from 'vue-property-decorator';
import ContactDirectory from '../../modules/contacts/directory/views/ContactDirectory.vue';
import { mapMutations } from 'vuex';
import { customerManagement } from '@/modules/shared/shared/store/namespaces';
import { CUSTOMER_MANAGEMENT_SET_SELECTED } from '@/modules/customers/store/customer-management.mutations';
import { CUSTOMER_MANAGEMENT_GET_SELECTED } from '@/modules/customers/store/customer-management.getters';

@Component({
    components: {
        ContactDirectory,
    },
    methods: {
        ...mapMutations('layout', ['changeTitle']),
    },
})
export default class CustomerManagement extends Vue {
    customer: number = -1;
    customerKey: boolean = true;
    customerOptions: any = {};
    customerSelected: any = {};
    headers: any[] = [
        { text: 'Cliente', sortable: false, value: 'name' },
        { text: 'RIF', sortable: false, value: 'rif' },
        { text: 'Estatus', value: 'adminUser' },
    ];
    itemsPerPage: number[] = [10, 20, 50, 100];
    limit: number = this.itemsPerPage[0];
    loadingCustomerInfo: boolean = false;
    loadingCustomers: boolean = false;
    loadingText: string = 'Obteniendo los clientes, espere un momento por favor';
    page: number = 1;
    noDataText: string = 'No hay clientes disponibles';
    search: string = '';
    snackbar: boolean = false;
    snackbarColor: string = '';
    snackbarText: string = '';
    start: number = 1;
    windowIndex: number = 1;
    windowKey: number = 1;

    async mounted() {
        //@ts-ignore
        this.changeTitle({ title: 'Administración', route: ['CLIENTES'] });
        if (this.$route.params.message || this.$route.params.canceled) {
            if (!this.$route.params.canceled) {
                this.snackbarColor = 'green';
                this.snackbarText = this.$route.params.message;
                this.snackbar = true;
                this.$route.params.message = '';
            }
            this.changeCustomer(this.GET_SELECTED);
        }
        await this.getCustomers();
    }

    @Watch('customerOptions.itemsPerPage')
    async onCustomerChanged(value) {
        this.limit = value;
        this.page = 1;
        await this.getCustomers();
    }
    @Watch('failedEquipmentTransaction')
    onFailedEquipmentTransactionChanged() {
        if (this.failedEquipmentTransaction) {
            this.openSnackbar(
                'Ocurrió un error obteniendo los clientes, por favor intente de nuevo',
                'red',
            );
        }
    }
    @Watch('resetCustomers')
    async onResetCustomersChanged() {
        if (this.resetCustomers) {
            this.loadingCustomerInfo = true;
        } else {
            await this.getCustomers();
            let customerAux: any = this.updateCustomer();
            if (customerAux != null) {
                this.customerSelected = customerAux;
            } else {
                this.changeWindow(1);
            }
            this.loadingCustomerInfo = false;
        }
    }
    @Watch('search')
    async onSearchChanged() {
        if (!this.search) {
            await this.getCustomers();
        }
    }
    get breadcrumbItems() {
        return [
            {
                text: 'Administración de clientes',
                disabled: false,
                href: '',
            },
            {
                text: this.customerSelected.name,
                disabled: true,
                href: '',
            },
        ];
    }

    get customers() {
        return this.$store.state.customers.results;
    }

    get failedEquipmentTransaction() {
        if (this.$store.state.failedEquipmentTransaction === 'Customers') {
            return true;
        } else {
            return false;
        }
    }

    get pages() {
        if (this.$store.state.customers.pages !== undefined) {
            if (this.page > this.$store.state.customers.pages) {
                this.page = this.$store.state.customers.pages;
                if (this.page !== 0) {
                    this.getCustomers();
                } else {
                    this.page = 1;
                }
            }
            return this.$store.state.customers.pages;
        } else {
            return 1;
        }
    }

    get resetCustomers() {
        return this.$store.state.resetContactDirectory || this.$store.state.resetDirectory;
    }

    changeCustomer(customerSelected: any) {
        if (customerSelected) {
            this.customer = customerSelected;
            this.customerSelected = customerSelected;
            this.SELECT_CUSTOMER(customerSelected);
            this.changeWindow(2);
            this.customerKey = !this.customerKey;
        }
    }

    changeWindow(windowIndex: number) {
        this.windowIndex = windowIndex;
        if (windowIndex === 1) {
            this.windowKey = this.windowKey === 1 ? 0 : 1;
        }
    }

    async getCustomers() {
        this.loadingCustomers = true;
        let customersOptions: { limit: number; start: number; keyword: string } = {
            limit: this.limit,
            start: this.page,
            keyword: this.search ? this.search.trim().replace(' ', '+') : this.search,
        };
        await this.$store.dispatch('getCustomers', customersOptions);
        this.loadingCustomers = false;
    }

    closeSnackbar() {
        this.snackbar = false;
        this.snackbarText = '';
    }

    openSnackbar(message: string, color: string) {
        this.snackbarText = message;
        this.snackbarColor = color;
        this.snackbar = true;
    }

    updateCustomer() {
        let customerAux: any = null;
        this.customers.forEach(customer => {
            if (customer.id === this.customerSelected.id) {
                customerAux = customer;
            }
        });
        return customerAux;
    }

    @customerManagement.Mutation(CUSTOMER_MANAGEMENT_SET_SELECTED) SELECT_CUSTOMER!: Function;
    @customerManagement.Getter(CUSTOMER_MANAGEMENT_GET_SELECTED) GET_SELECTED;
}
